import {
    Button,
    Card,
    CardContent as MuiCardContent,
    Checkbox,
    FormControl,
    FormControlLabel,
    Grid,
    TextField
} from '@material-ui/core'
import {spacing} from '@material-ui/system'
import {Autocomplete, CircularProgressBar} from 'app/Components'
import {onKeyDown} from 'external-lib/utils/helpers'
import {Formik} from 'formik'
import {isLoading, isProcessing} from 'lib/progress'
import {Source} from 'lib/select'
import {State} from 'lib/store'
import React from 'react'
import {connect, MapStateToProps} from 'react-redux'
import styled from 'styled-components'
import * as Yup from 'yup'
import {TestConfig} from "lib/testConfig";
import {Dictionaries} from "lib/dictionaries";

const CardContent = styled(MuiCardContent)(spacing)

type StateToProps = {
    readonly isLoading: boolean
    readonly isProcessing: boolean
}

type FormControlProps = {
    initialValues: TestConfig
    handleSubmit: (testConfig: TestConfig) => void
}

const Schema = Yup.object().shape({})

class FormComponent extends React.Component<FormControlProps & StateToProps> {
    public render = () =>
        <>
            {
                this.props.isLoading
                    ? <CircularProgressBar/>
                    : <Formik
                        initialValues={this.props.initialValues}
                        validationSchema={Schema}
                        onSubmit={values => this.props.handleSubmit(values)}
                    >
                        {({
                              values,
                              errors,
                              touched,
                              handleChange,
                              handleBlur,
                              handleSubmit,
                              isSubmitting,
                              setFieldValue
                          }) => (
                            <form onSubmit={handleSubmit} onKeyDown={onKeyDown}>

                                <Card variant="outlined">
                                    <CardContent>

                                        <Grid container spacing={2}>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControl margin="dense" fullWidth>
                                                    <TextField
                                                        label="Nazwa testu"
                                                        id="name"
                                                        name="name"
                                                        variant="outlined"
                                                        disabled
                                                        value={values.name}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControl margin="dense" fullWidth>
                                                    <Autocomplete
                                                        label={"Rola"}
                                                        field={'roles'}
                                                        source={Source.ROLES}
                                                        value={values.roles || []}
                                                        error={Boolean(errors.roles && touched.roles)}
                                                        multiple={true}
                                                        setFieldValue={setFieldValue}
                                                        helperText={errors.roles as string}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControl margin="dense" fullWidth>
                                                    <Autocomplete
                                                        label={"Specjalizacje"}
                                                        field={'specialties'}
                                                        source={Source.DICTIONARIES}
                                                        value={values.specialties || []}
                                                        error={Boolean(errors.specialties && touched.specialties)}
                                                        multiple={true}
                                                        setFieldValue={setFieldValue}
                                                        requestOptions={{type: Dictionaries.Specialty}}
                                                        helperText={errors.specialties as string}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControl margin="dense" fullWidth>
                                                    <Autocomplete
                                                        label={"Kwalifikacje"}
                                                        field={'qualifications'}
                                                        source={Source.DICTIONARIES}
                                                        value={values.qualifications || []}
                                                        error={false}
                                                        multiple={true}
                                                        setFieldValue={setFieldValue}
                                                        requestOptions={{type: Dictionaries.Qualification}}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControlLabel
                                                    control={<Checkbox id="startingPackage" checked={values.startingPackage}
                                                                       onChange={handleChange}
                                                                       color="primary"/>}
                                                    label="Test startowy"
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControlLabel
                                                    control={<Checkbox id="availableForParents" checked={values.availableForParents}
                                                                       onChange={handleChange}
                                                                       color="primary"/>}
                                                    label="Dostępny dla rodziców"
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControlLabel
                                                    control={<Checkbox id="active" checked={values.active}
                                                                       onChange={handleChange}
                                                                       color="primary"/>}
                                                    label="Aktywny"
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => handleSubmit()}
                                                    disabled={this.props.isProcessing}
                                                >
                                                    Zapisz
                                                </Button>
                                            </Grid>
                                        </Grid>

                                    </CardContent>
                                </Card>
                            </form>
                        )}
                    </Formik>
            }
        </>
}

const mapStateToProps: MapStateToProps<StateToProps, {}, State> = state => ({
    isLoading: isLoading(state),
    isProcessing: isProcessing(state),
})

export const Form = connect(mapStateToProps)(FormComponent)